// import React from 'react';
// import styled from 'styled-components'
// import { PowerBtn } from '../components/AllSvgs';
// import { NavLink } from 'react-router-dom';


// const  Power = styled.button `
// position: fixed;
// bottom: 2rem;
// left: 50%;
// transform: translate(-50%, 0);

// background-color: #FCF6F4;
// padding: 0.3rem;
// border-radius: 50%;
// border: 1px solid #000;
// width: 2.5rem;
// height: 2.5rem;

// display: flex;
// justify-content: center;
// align-items: center;
// z-index: 3;

// cursor: pointer;

// &:hover{
//     background-color: rgba(0, 255, 0 ,0.4);
//     box-shadow: 0 0 8px 6px rgba(0. 255, 0 , 0.2);
// }

// &>*:first-child{
//     text-decoration: none;
//     color: inherit;
// }
// `


// const PowerButton = () => {
//   return (
//     <Power>
//        <NavLink to='/'>
//        <PowerBtn height={30} width={30} fill='currentColor' />
//        </NavLink>
//     </Power>
//   )
// }

// export default PowerButton








// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// // import { About, Contact, Home, PowerBtn, Skills, Work } from "../components/AllSvgs";
// // import { About, Mail, Home, PowerBtn, Skills, WorkCase } from "../components/AllSvgs";
// import {PowerBtn} from "../components/AllSvgs";


// import  About from '../assets/NavIcons/About_icon.png';
// import  Mail from '../assets/NavIcons/Contact_icon.png';
// import  Home from '../assets/NavIcons/Home_Icon.png';
// import  Skills from '../assets/NavIcons/SKills_icon.png';
// import  WorkCase from '../assets/NavIcons/Projects_icon1.png';


// import { NavLink, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

// // Wrapper for the Power Button and Nav Buttons
// const PowerWrapper = styled.div`
//   position: fixed;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 100px;
//   height: 100px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 10000;

//   /* Dynamically change position based on screen size */
//   top: ${(props) => (props.isMobile ? "auto" : "1.5rem")}; /* Desktop: top */
//   bottom: ${(props) => (props.isMobile ? "1.5rem" : "auto")}; /* Mobile: bottom */
// `;

// // Power Button (Toggle)
// const Power = styled.button`
//   background-color: #fcf6f4;
//   padding: 0.3rem;
//   border-radius: 50%;
//   border: 1px solid #000;
//   width: 3rem;
//   height: 3rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
//   transition: background-color 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     background-color: rgba(0, 255, 0, 0.4);
//     box-shadow: 0 0 8px 6px rgba(0, 255, 0, 0.2);
//   }
// `;

// // Navigation Buttons
// const NavButton = styled(motion.div)`
//   width: 2.5rem;
//   height: 2.5rem;
//   background-color: ${(props) => props.color || "#fff"};
//   border-radius: 50%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: absolute;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
//   cursor: pointer;
//   transition: transform 0.3s ease;

//   &:hover {
//     transform: scale(1.1);
//   }
// `;

// const PowerButton = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const navigate = useNavigate(); // To redirect user on desktop

//   // Detect screen size changes
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const toggleNav = () => {
//     if (!isMobile) {
//       navigate("/"); // Redirect on desktop
//     } else {
//       setIsOpen((prev) => !prev);
//     }
//   };

//   // ✅ Positions (Correctly placed around the Power Button at the bottom)
//   const positions = [
//     { x: 0, y: 0 }, // Center (For smooth animation)
//     { x: 0, y: -60 }, // Directly above Power Button
//     { x: 50, y: -50 }, // Bottom-right
//     { x: 60, y: 0 }, // Right
//     { x: -50, y: -50 }, // Bottom-left
//     { x: -60, y: 0 }, // Left
//   ];


//   const icons = [
//     <img src={Home} alt="Home" width="35" height="35" />,
//     <img src={Skills} alt="Skills" width="35" height="35" />,
//     <img src={Mail} alt="Mail" width="35" height="35" />,
//     <img src={WorkCase} alt="Projects" width="35" height="35" />,
//     <img src={About} alt="About" width="35" height="35" />,
// ];

  

//   return (
//     <PowerWrapper isMobile={isMobile}>
//       {/* Show nav buttons only on mobile */}
//       {isMobile &&
//         positions.slice(1).map((pos, index) => (
//           <NavLink
//             key={index}
//             to={["/", "/contact", "/work", "/skills", "/about"][index]}
//           >
//             {/* <NavButton
//               color={["#FF4757", "#1E90FF", "#2ED573", "#F39C12", "#8E44AD"][index]}
//               initial={{ opacity: 0, x: 0, y: 0 }}
//               animate={isOpen ? { opacity: 1, x: pos.x, y: pos.y } : { opacity: 0, x: 0, y: 0 }}
//               transition={{ type: "spring", stiffness: 200, damping: 10, delay: index * 0.1 }}
//             >
//               {["🏠", "👤", "✉️", "⚙️", "🚪"][index]}
//             </NavButton>
//              */}
//              <NavButton
//   color={["rgb(17, 21, 25)", "rgb(17, 21, 25)", "  rgb(17, 21, 25)", "   rgb(17, 21, 25)", "rgb(17, 21, 25)"][index]}
//   border={["2px solid #000", "2px solid #000", "2px solid #000", "2px solid #FFF", "2px solid #000"] [index]}
//   initial={{ opacity: 0, x: 0, y: 0 }}
//   animate={isOpen ? { opacity: 1, x: pos.x, y: pos.y } : { opacity: 0, x: 0, y: 0 }}
//   transition={{ type: "spring", stiffness: 200, damping: 10, delay: index * 0.1 }}
// >
//   {icons[index]}
// </NavButton>

//           </NavLink>
//         ))}

//       {/* Power Toggle Button */}
//       <Power onClick={toggleNav}>
//         <PowerBtn height={30} width={30} fill="currentColor" />
//       </Power>
//     </PowerWrapper>
//   );
// };

// export default PowerButton;






// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import { PowerBtn } from "../components/AllSvgs";

// import About from "../assets/NavIcons/About_icon.png";
// import Mail from "../assets/NavIcons/Contact_icon.png";
// import Home from "../assets/NavIcons/Home_Icon.png";
// import Skills from "../assets/NavIcons/SKills_icon.png";
// import WorkCase from "../assets/NavIcons/Projects_icon1.png";

// import { NavLink, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

// // Wrapper for the Power Button and Nav Buttons
// const PowerWrapper = styled.div`
//   position: fixed;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 120px;
//   height: 120px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 10000;

//   /* Dynamically change position based on screen size */
//   top: ${(props) => (props.isMobile ? "auto" : "1.5rem")}; 
//   bottom: ${(props) => (props.isMobile ? "1.5rem" : "auto")}; 
// `;

// // Power Button (Toggle)
// const Power = styled.button`
//   background-color: #fcf6f4;
//   padding: 0.5rem;
//   border-radius: 50%;
//   border: 2px solid #000;
//   width: 4rem;
//   height: 4rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
//   transition: background-color 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     background-color: rgba(0, 255, 0, 0.4);
//     box-shadow: 0 0 8px 6px rgba(0, 255, 0, 0.2);
//   }
// `;

// // Navigation Buttons
// const NavButton = styled(motion.div)`
//   width: 3.5rem;
//   height: 3.5rem;
//   background-color: black;
//   border-radius: 50%;
//   border: 2px solid white;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: absolute;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
//   cursor: pointer;
//   transition: transform 0.3s ease;

//    /* Disable clicks until animation is done */
//   pointer-events: ${(props) => (props.animationComplete ? "auto" : "none")};

//   &:hover {
//     transform: scale(1.15);
//   }
// `;

// const PowerButton = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [animationComplete, setAnimationComplete] = useState(false); // Track animation

//   const navigate = useNavigate();

//   // Detect screen size changes
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const toggleNav = () => {
//     if (!isMobile) {
//       navigate("/");
//     } else {
//       setAnimationComplete(false); // Disable clicks before animation starts
//       setIsOpen((prev) => !prev);
//       // Wait for animation to complete before enabling clicks (set timeout)
//       setTimeout(() => {
//         setAnimationComplete(true);
//       }, 500); // Adjust based on animation duration
    
//     }
//   };

//   // New positions to prevent button collision
//   const positions = [
//     { x: 0, y: -95 }, // Top
//     { x: 68, y: -73 }, // Top-right
//     { x: 77, y: 0 }, // Right
//     { x: -68, y: -73 }, // Top-left
//     { x: -77, y: 0 }, // Left
//   ];

//   const icons = [
//     <img src={Home} alt="Home" width="40" height="40" />,
//     <img src={Skills} alt="Skills" width="40" height="40" />,
//     <img src={Mail} alt="Mail" width="40" height="40" />,
//     <img src={WorkCase} alt="Projects" width="40" height="40" />,
//     <img src={About} alt="About" width="40" height="40" />,
//   ];

//   return (
//     <PowerWrapper isMobile={isMobile}>
//       {isMobile &&
//         positions.map((pos, index) => (
//           <NavLink key={index} to={["/", "/skills", "/contact", "/work", "/about"][index]}>
//             <NavButton
//               animationComplete={animationComplete}
//               initial={{ opacity: 0, x: 0, y: 0, rotate: 0 }}
//               animate={isOpen ? { 
//                 opacity: 1, 
//                 x: pos.x, 
//                 y: pos.y, 
//                 rotate: 360 
//               } : { 
//                 opacity: 0, 
//                 x: 0, 
//                 y: 0, 
//                 rotate: 0 
//               }}
//               transition={{ duration: 0.4, ease: "easeOut", delay: index * 0.1 }}
//             >
//               {icons[index]}
//             </NavButton>
//           </NavLink>
//         ))}

//       {/* Power Toggle Button */}
//       <Power onClick={toggleNav}>
//         <PowerBtn height={35} width={35} fill="currentColor" />
//       </Power>
//     </PowerWrapper>
//   );
// };

// export default PowerButton;







import { useState, useEffect } from "react"
import styled from "styled-components"
import { PowerBtn } from "../components/AllSvgs"
import { NavLink, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"

// Import icons (assuming these imports are correct)
import About from "../assets/NavIcons/About_icon.png"
import Mail from "../assets/NavIcons/Contact_icon.png"
import Home from "../assets/NavIcons/Home_Icon.png"
import Skills from "../assets/NavIcons/SKills_icon.png"
import WorkCase from "../assets/NavIcons/Projects_icon1.png"

// Wrapper for the Power Button and Nav Buttons
const PowerWrapper = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;

  top: ${(props) => (props.isMobile ? "auto" : "1.5rem")};
  bottom: ${(props) => (props.isMobile ? "1.5rem" : "auto")};
`

// Power Button (Toggle)
const Power = styled.button`
  background-color: #fcf6f4;
  padding: 0.5rem;
  border-radius: 50%;
  border: 2px solid #000;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background-color: rgba(0, 255, 0, 0.4);
    box-shadow: 0 0 8px 6px rgba(0, 255, 0, 0.2);
  }
`

// Navigation Buttons
const NavButton = styled(motion.div)`
  width: 3.5rem;
  height: 3.5rem;
  background-color: black;
  border-radius: 50%;
  border: 2px solid white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform 0.3s ease;
  pointer-events: ${(props) => (props.animationComplete ? "auto" : "none")};

  &:hover {
    transform: scale(1.15);
  }
`

// New styled component for the label
const NavLabel = styled(motion.span)`
  color: white;
  font-size: 0.7rem;
  margin-top: 0.2rem;
  text-align: center;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition: opacity 0.3s ease;
`

const PowerButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [animationComplete, setAnimationComplete] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const toggleNav = () => {
    if (!isMobile) {
      navigate("/")
    } else {
      setAnimationComplete(false)
      setIsOpen((prev) => !prev)
      setTimeout(() => {
        setAnimationComplete(true)
      }, 500)
    }
  }

 
  const positions = [
    { x: 0, y: -95 }, // Top
    { x: 60, y: -65 }, // Top-right
    { x: 65, y: 0 }, // Right
    { x: -60, y: -65 }, // Top-left
    { x: -65, y: 0 }, // Left
  ];

  const navItems = [
    { icon: Home, label: "Home", path: "/" },
    { icon: Skills, label: "Skills", path: "/skills" },
    { icon: Mail, label: "Contact", path: "/contact" },
    { icon: WorkCase, label: "Projects", path: "/work" },
    { icon: About, label: "About", path: "/about" },
  ]

  return (
    <PowerWrapper isMobile={isMobile}>
      {isMobile &&
        navItems.map((item, index) => (
          <NavLink key={index} to={item.path}>
            <NavButton
              animationComplete={animationComplete}
              initial={{ opacity: 0, x: 0, y: 0, rotate: 0 }}
              animate={
                isOpen
                  ? {
                      opacity: 1,
                      x: positions[index].x,
                      y: positions[index].y,
                      rotate: 360,
                    }
                  : {
                      opacity: 0,
                      x: 0,
                      y: 0,
                      rotate: 0,
                    }
              }
              transition={{ duration: 0.4, ease: "easeOut", delay: index * 0.1 }}
            >
              <img src={item.icon || "/placeholder.svg"} alt={item.label} width="30" height="30" />
              <NavLabel
                isOpen={isOpen}
                initial={{ opacity: 0 }}
                animate={{ opacity: isOpen ? 1 : 0 }}
                transition={{ duration: 0.2, delay: 0.2 }}
              >
                {item.label}
              </NavLabel>
            </NavButton>
          </NavLink>
        ))}

      <Power onClick={toggleNav}>
        <PowerBtn height={35} width={35} fill="currentColor" />
      </Power>
    </PowerWrapper>
  )
}

export default PowerButton

